<template>
  <span>
    <sidebar-module-info
      ref="sidebarModuleInfo"
      :filtered-attributes="filteredAttributes"
      module-name="transmission_easement"
      parent-module-name="transmission_easements"
      permissions-path="TRANSMISSION_EASEMENT"
      :module-objects="easements"
      :get-object="getEasementObject"
      :handle-object-adding="handleEasementAdd"
      :handle-object-deleting="deleteEasement"
      :handle-object-editing="handleEasementEditing"
      :inputs="inputs"
      :new-object-payload="newEasementObject"
      :toggle-object-adding="toggleEasementAdding"
      :zoom-to-object="zoomToEasement"
      has-back-button
      has-basic-attributes
      :has-assigned-objects="false"
    >
      <template #status="scope">
        <sidebar-status-select v-model="scope.payload[scope.name]" v-bind="scope" />
      </template>
      <template #geometry="scope">
        <sidebar-geometry-input
          v-bind="scope"
          v-model="scope.payload[scope.name]"
          :is-valid.sync="scope.slotsValid[scope.name]"
        />
      </template>
    </sidebar-module-info>
  </span>
</template>
<script>
import { call, get } from 'vuex-pathify';
import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import SidebarGeometryInput from '@/components/SidebarGeometryInput';
import SidebarStatusSelect from '@/components/SidebarStatusSelect';
export default {
  name: 'TransmissionEasement',
  components: { SidebarModuleInfo, SidebarGeometryInput, SidebarStatusSelect },
  data: () => ({
    schema: [],
    filteredAttributes: ['id', 'status'],
  }),
  computed: {
    easements: get('layers/easements'),
    attributesMetadata: get('layers/metadata@:dataSource'),
    dataSource: get('admin/modulesMapping@transmission_easement.datasource_name'),
    computedGeometryName() {
      if (this.attributesMetadata) {
        return this.attributesMetadata.attributes_schema.geometry_name;
      }
      return 'geometry';
    },

    newEasementObject() {
      return {};
    },
    inputs() {
      return {
        new: [
          {
            name: 'status',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            hasDivider: true,
            cols: 'auto',
            type: 'transmission_easement',
            colors: {
              not_established: {
                color: 'rgba(0,145,234)',
                shadowColor: 'rgba(0,145,234,0.2)',
              },
              established: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              establishing_in_progress: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
            },
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            oneLineInput: false,
            cols: '12',
            hint: this.$i18n.t('dialog.easementGeometryInputHint'),
            hintWithValue: this.$i18n.t('dialog.easementGeometryInputHint'),
            geometryType: 'Polygon',
            assignGeometryType: 'Polygon',
            hasAssignGeometry: true,
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
        ],
        edit: [
          {
            name: 'status',
            translationPath: 'dialog.status',
            icon: 'mdi-progress-check',
            hasDivider: true,
            cols: 'auto',
            type: 'transmission_easement',
            colors: {
              not_established: {
                color: 'rgba(0,145,234)',
                shadowColor: 'rgba(0,145,234,0.2)',
              },
              established: {
                color: 'rgba(24,128,56)',
                shadowColor: 'rgba(24,128,56,0.2)',
              },
              establishing_in_progress: {
                color: 'rgba(255,136,0)',
                shadowColor: 'rgba(255,136,0,0.2)',
              },
            },
          },
          {
            sectionTitle: 'sidebar.geometrySectionTitle',
            name: 'geometry',
            icon: 'mdi-map-marker',
            hasNameColumn: false,
            oneLineInput: false,
            cols: '12',
            hint: this.$i18n.t('dialog.easementGeometryInputHint'),
            geometryType: 'Polygon',
            assignGeometryType: 'Polygon',
            hasAssignGeometry: true,
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
        ],
      };
    },
  },
  methods: {
    getEasement: call('layers/getEasement'),
    addEasement: call('layers/addEasement'),
    deleteEasement: call('layers/deleteEasement'),
    editEasement: call('layers/editEasement'),

    async handleEasementAdd(payload) {
      const feature = {
        [this.computedGeometryName]: payload.geometry,
      };
      delete payload['geometry'];
      const featureModified = {
        ...feature,
        ...payload,
      };
      const r = await this.addEasement(featureModified);
      return r.data.data;
    },
    async handleEasementEditing(payload) {
      const easement_id = payload.id;
      delete payload.id;
      const featureBasic = {
        [this.computedGeometryName]: payload.geometry,
      };
      delete payload['geometry'];
      const feature = {
        ...featureBasic,
        ...payload,
      };
      await this.editEasement({ easement_id, feature });
    },
    async getEasementObject(id) {
      const r = await this.getEasement(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    toggleEasementAdding() {
      this.$router.push({
        name: 'transmission_easement',
        params: { fid: 'new' },
      });
    },
    zoomToEasement(layerId, layerGroup, featureId) {
      this.$root.$emit('zoomToFeature', layerId, layerGroup, featureId);
    },
  },
};
</script>

<style scoped lang="scss">
.border-bottom {
  @include border(bottom);
}
</style>
